$(document).ready(function(){
  $("body").on('click','.gladlyHC-faqSection',function(){
    //$(".gladlyHC-faqSection-header").removeClass('active');
    $(this).find("h3").toggleClass('active');
    //$("div.gladlyHC-faqSection ul").removeClass('active');
      $(this).find("ul.gladlyHC-faqSection-list").toggleClass('active');
  })
});